<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    data() {
        return {
            newPassword: '',
            newPasswordConfirm: ''
        }
    },
    props: {
        userResource: {
            type: Object,
            required: true
        }
    },
    methods: {
        async onSubmit() {
            try {
                let user = await this.userResource.setPassword(this.newPassword)
                this.$emit('success', user)
            } catch(e) {
                throw this.axiosExtract(e)
            }
        },
        isValid() {
            return this.newPassword && this.newPassword === this.newPasswordConfirm
        }
    },
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-card class="mt-5" :header="!userResource.isOnboarded() ? 'Establecer Contraseña' : 'Cambiar Contraseña'">
            <b-alert variant="success" v-if="!userResource.isOnboarded()" show>Aún no has establecido una contraseña</b-alert>
            <b-form-group label="Nueva Contraseña:">
                <b-form-input type="password" v-model="newPassword" autocomplete="new-password" />
            </b-form-group>
            <b-form-group label="Nueva Contraseña (otra vez):">
                <b-form-input type="password" v-model="newPasswordConfirm" autocomplete="new-password" />
            </b-form-group>
            <messages />
            <template slot="footer">
                <b-button :to="{ name: 'dashboard' }" variant="link" size="sm">Cancelar</b-button>
                <b-button type="submit" :disabled="!isValid()" class="float-right">Enviar</b-button>
            </template>
        </b-card>
    </b-form>
</template>